export default "__VITE_ASSET__CefX5dE9__"